import { DOCUMENT_VIEWER_DETAIL_FIELD_TEST_ID } from '@ctw/shared/test/ids';
import type { CdaDetailField } from '@ctw/shared/utils/cda/types';
import { tw, twx } from '@ctw/shared/utils/tailwind';
import { orderBy } from 'lodash-es';

export interface DocumentViewerDetailFieldsProps {
  fields: Array<CdaDetailField>;
}

export const DocumentViewerDetailFields = ({ fields }: DocumentViewerDetailFieldsProps) => (
  <dl
    data-testid={DOCUMENT_VIEWER_DETAIL_FIELD_TEST_ID}
    className={twx(
      'grid w-full grid-flow-col-dense grid-cols-1 grid-rows-12 gap-6 sm:grid-cols-2 sm:grid-rows-4 md:grid-cols-3 md:grid-rows-2',
    )}
  >
    {orderBy(fields, 'rank').map((field) => (
      <div key={field.label} className={tw`my-auto block flex-1 space-y-2`}>
        <dt
          className={tw`block whitespace-nowrap font-medium text-content-main/55 text-xs uppercase leading-none tracking-wide`}
        >
          {field.label}
        </dt>
        <dd className={tw`block font-normal text-content-main text-sm leading-none`}>
          {field.value}
        </dd>
      </div>
    ))}
  </dl>
);
